import React from 'react';
import clsx from 'clsx';

import styles from './Preloader.module.scss';

export type PreloaderProps = {
  className?: string;
};

export const Preloader: React.FC<PreloaderProps> = ({ className }) => (
  <div className={clsx(styles.root, className)}>
    <svg width="42" height="39" viewBox="0 0 42 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="38.5683" cy="19.1175" r="2.59042" transform="rotate(90 38.5683 19.1175)" />
      <circle cx="2.59025" cy="19.1175" r="2.59042" transform="rotate(90 2.59025 19.1175)" />
      <circle cx="29.5737" cy="34.6966" r="2.59042" transform="rotate(150 29.5737 34.6966)" />
      <circle cx="11.585" cy="3.53866" r="2.59042" transform="rotate(150 11.585 3.53866)" />
      <circle cx="11.585" cy="34.6965" r="2.59042" transform="rotate(-150 11.585 34.6965)" />
      <circle cx="29.5738" cy="3.53857" r="2.59042" transform="rotate(-150 29.5738 3.53857)" />
    </svg>
  </div>
);
